import { z } from "zod";

const UsStateSchema = z.object({
  name: z.string(),
  zip_code: z.string(),
  code: z.string(),
});

export const UsStatesResponseSchema = z.object({
  us_states: UsStateSchema.array(),
});
